import { getUrl } from 'helpers';
import styled from 'styled-components';

export const Container = styled.div`
    align-items: center;
    background-color: #000000;
    background-image: url(${getUrl('/assets/landing/background.png')});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    flex: 1;
    justify-content: center;
    overflow-x: hidden;
    padding: 48px;
    position: relative;
`;

export const Content = styled.div`
    color: white;
    max-width: 800px;
    padding: 48px;
    position: relative;
    z-index: 2;
`;

export const ContentGradient = styled.div`
    background: linear-gradient(179.92deg, rgba(26, 26, 26, 0.8) 26.38%, rgba(26, 26, 26, 0) 94.51%);
    border-radius: 40px;
    bottom: 0;
    filter: drop-shadow(0px 2px 4px rgba(33, 36, 41, 0.05));
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
`;
